import { render, staticRenderFns } from "./OrderTableFilter.vue?vue&type=template&id=5081b322&scoped=true"
import script from "./OrderTableFilter.vue?vue&type=script&lang=js"
export * from "./OrderTableFilter.vue?vue&type=script&lang=js"
import style0 from "./OrderTableFilter.vue?vue&type=style&index=0&id=5081b322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081b322",
  null
  
)

export default component.exports